import React from 'react';

import { ButtonProps as MuiButtonProps } from '@mui/material';
import { isNotNil } from 'es-toolkit';

import { arrayJoin } from '@hrlogics/helper-utils';

import { noop } from '@clearverify/utils';

import { useModalV2 } from 'src/hooks/shared';
import { ModalV2Props } from 'src/types/modalV2';

import { BaseConfirmationModal } from './BaseConfirmationModal';

export type EntityActionConfirmationModalProps = {
  onSubmit: () => void | Promise<void>;
  action: string;
  entity: string;
  actionButtonColor?: MuiButtonProps['color'];
  maxWidth?: false | number | 'auto';
};

export const EntityActionConfirmationModal: React.FC<
  ModalV2Props<EntityActionConfirmationModalProps>
> = ({ id, action, onSubmit = noop, entity, actionButtonColor = 'primary', maxWidth }) => {
  const { closeModal } = useModalV2();

  const buttonText = arrayJoin(['Yes', action].filter(isNotNil));
  const contentText =
    entity && action
      ? `Please confirm that you would like to ${action} ${entity}`
      : 'Confirm you want to proceed?';

  const onCloseModal = React.useCallback(() => {
    closeModal(id);
  }, [closeModal, id]);

  const onSubmitModal = React.useCallback(async () => {
    await onSubmit();
    onCloseModal();
  }, [onCloseModal, onSubmit]);

  return (
    <BaseConfirmationModal
      isOpen
      onSubmit={onSubmitModal}
      onClose={onCloseModal}
      maxWidth={maxWidth}
      title="Are You sure?"
      contentText={contentText}
      buttonText={buttonText}
      actionButtonColor={actionButtonColor}
    />
  );
};
